import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ExtensionFilter from './ExtensionFilter';
import ExtensionReference from './ExtensionReference';
import ExtensionAuto from './ExtensionAuto';

export default function AnalysisSales() {
  const [selectedTab, setSelectedTab] = useState('filter');

  const handleChangeTab = async (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleChangeTab} textColor="secondary" indicatorColor="secondary" sx={{ mb: 1 }}>
        <Tab label="필터" value="filter" />
        <Tab label="참조" value="reference" />
        <Tab label="신규파일자동업로드" value="auto" />
      </Tabs>

      {selectedTab === 'filter' && <ExtensionFilter />}
      {selectedTab === 'reference' && <ExtensionReference />}
      {selectedTab === 'auto' && <ExtensionAuto />}
    </Box>
  );
}
